<template>
<div class="chapter">
<div class="inner_page">
<p class="SP1"> </p>
<p class="DED"><span class="ePub-I">For Priscilla, Susannah, and Jennifer, with love</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5b2835f6